module.exports = __webpack_public_path__ + "static/media/ICastelli.6e9ffae8.png";